import { defineCopy } from './index';

/** Home, Play hub, Me, Settings and Admin: the screens the shell composes from module parts. */
export const screensCopy = defineCopy('screens', {
  home: {
    title: 'What went down',
    empty: 'Quiet in here. Somebody go miss a layup.',
  },
  play: {
    title: "Who's got next?",
    sub: 'Pick a format. The book keeps itself.',
    empty: 'No formats yet. The builders are still on the court.',
  },
  me: {
    title: 'Me',
    guest: 'Signed in',
    owner: 'Owner',
    member: 'Member',
    settings: 'Settings',
    admin: 'Crew admin',
    signOut: 'Sign out on this phone',
    signedOut: 'Signed out. See you on the court.',
  },
  settings: {
    title: 'Settings',
    sun: 'Sun mode',
    sunHelp: 'White ground and darker lines for a bright court.',
    sound: 'Sound',
    soundHelp: 'Swish, clank and buzzer. The silent switch still wins.',
    haptics: 'Buzz on tap',
    hapticsHelp: 'Android only. iPhones get a sound tick instead.',
    motion: 'Motion',
    motionSystem: 'Phone setting',
    motionReduce: 'Less',
    motionFull: 'Full',
    version: 'Version {v}',
  },
  admin: {
    title: 'Crew admin',
    empty: 'Nothing to run yet. The modules bring their own switches.',
    ownerOnly: 'Owner only. Ask the person who set this up.',
  },
});
